import {Injectable} from '@angular/core';
import {Store} from '@ngrx/store';
import {PartnerClientVO,  PartnerClientListVO} from './partner-client.interfaces';
import {partnerClientDefinition, PartnerClientState} from './partner-client.reducers';
import {FullCrudFacade, PayloadWithRequestId, TerminateOnFirstExecutor} from '@abydos-angular/store';
import {PartnerClientRepository} from './partner-client.repository';
@Injectable()
export class PartnerClientFacade extends FullCrudFacade<PartnerClientVO, PartnerClientListVO, PartnerClientState> {

    constructor(store: Store<PartnerClientState>, private partnerClientRepository: PartnerClientRepository) {
        super(store, partnerClientDefinition);
    }

    getWithCallback(idValue: number, onSuccess: (result: PartnerClientVO | null | undefined) => void) {
        new TerminateOnFirstExecutor((result:PayloadWithRequestId<PartnerClientVO>) => {
          onSuccess(result.payload);
        }).run(this.partnerClientRepository.get(idValue));
    }
}
